import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout as AntLayout, Menu, Dropdown, Avatar, Space } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { filterMenuByRole, topMenuConfig } from '../config/menuConfig';
import { useAuth } from '../context/AuthContext';
import { getUserDisplayName, logoutSession, getLoginUrl } from '../api/auth';

const { Header, Content, Sider } = AntLayout;

const Layout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const { session } = useAuth();
  const role = session.identity?.traits?.role as string | undefined;
  const visibleMenus = filterMenuByRole(topMenuConfig, role);

  const topMenuItems = visibleMenus.map((item) => ({
    key: item.key,
    icon: item.icon,
    label: item.label,
  }));

  const currentTopKey = '/' + (pathname.split('/').filter(Boolean)[0] || 'shipments');
  const currentConfig = visibleMenus.find((c) => c.key === currentTopKey);
  const sideItems = currentConfig?.children?.map((child) => ({
    key: child.key,
    label: child.label,
  })) ?? [];

  const handleLogout = async () => {
    const loginUrl = getLoginUrl();
    try {
      await logoutSession(loginUrl);
      window.location.href = loginUrl;
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ];

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', background: '#001529', paddingInline: 24 }}>
        <div style={{ color: '#fff', marginRight: 24, fontWeight: 600, flexShrink: 0 }}>
          KFC 凯飞越履行中心
        </div>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[currentTopKey]}
          items={topMenuItems}
          onClick={({ key }) => {
            const config = visibleMenus.find((c) => c.key === key);
            const firstChild = config?.children?.[0]?.key;
            navigate(firstChild || key);
          }}
          style={{ flex: 1, minWidth: 0 }}
        />
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Space style={{ color: '#fff', cursor: 'pointer', flexShrink: 0, marginLeft: 16 }}>
            <Avatar size="small" icon={<UserOutlined />} />
            <span>{getUserDisplayName(session)}</span>
          </Space>
        </Dropdown>
      </Header>
      <AntLayout>
        {sideItems.length > 0 && (
          <Sider width={240} style={{ background: '#fff' }}>
            <Menu
              mode="inline"
              selectedKeys={[pathname]}
              items={sideItems}
              onClick={({ key }) => navigate(key)}
              style={{ height: '100%', borderRight: 0 }}
            />
          </Sider>
        )}
        <Content style={{ padding: 24, background: '#f0f2f5' }}>
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
